import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import {getPriorPeriodStartWeekId} from '../../../utils/periodUtils';
import {addLabelToOptionsIfNotExist} from "../../../utils/maybeAddLabelToOptions";
import SelectDropdown from "../../Components/Dropdowns/SelectDropdown";

const AdditionalPeriodsDropdown = ({endPeriod, onChange, additionalPeriods, additionalPeriodsUpdate, width = 250}) => {

    useEffect(() => {
        getPriorPeriodStartWeekId(additionalPeriods.value, endPeriod.quadId)
            .then(startWeekId => onChange(startWeekId));
    }, [endPeriod]);

    return (<SelectDropdown
            id={'additional_periods_dropdown'}
            dataTestId={"additional-periods-wrapper"}
            className={"select-dropdown"}
            classNamePrefix={"select-dropdown"}
            selectValue={additionalPeriods.value}
            width={width}
            options={addLabelToOptionsIfNotExist([...Array(14).keys()])}
            onChange={(option) => {
                additionalPeriodsUpdate(option);
                getPriorPeriodStartWeekId(option.value, endPeriod.quadId)
                    .then(startWeekId => onChange(startWeekId));
            }}
        />);
};


AdditionalPeriodsDropdown.propTypes = {
    additionalPeriods: PropTypes.object,
    additionalPeriodsUpdate: PropTypes.func,
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    endPeriod: PropTypes.shape({
        periodAbbreviation: PropTypes.string,
        weekId: PropTypes.number,
        quadId: PropTypes.number
    }),
    onChange: PropTypes.func
};

export default AdditionalPeriodsDropdown;
